const audiences = [
  {
    icon: 'ri-user-star-line',
    title: 'Новые руководители',
    desc: 'Освоение базовых инструментов обратной связи и управленческой коммуникации. Переход от роли коллеги к роли руководителя, который умеет давать конструктивную обратную связь.',
  },
  {
    icon: 'ri-team-line',
    title: 'Руководители среднего звена',
    desc: 'Работа со сложными сотрудниками, конфликтами и результатами. Развитие навыков проведения разговоров, которые реально меняют поведение команды.',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'РОПы',
    desc: 'Обратная связь по продажам, KPI, звонкам, переговорам и дисциплине выполнения задач. Как обсуждать цифры и поведение, не демотивируя отдел продаж.',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Топ-менеджеры',
    desc: 'Сложные коммуникации с руководителями подразделений и ключевыми сотрудниками. Как давать обратную связь тем, от кого зависит бизнес.',
  },
  {
    icon: 'ri-building-line',
    title: 'Управленческие команды',
    desc: 'Формирование единого подхода к обратной связи внутри компании. Чтобы все руководители использовали общие принципы и инструменты.',
  },
];

export default function SuitableFor() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Для кого подходит программа
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Программа адаптируется под уровень руководителей и специфику управленческих задач компании
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {audiences.map((a) => (
            <div key={a.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors group">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${a.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{a.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{a.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}